import {  t  } from "@/client/libs/dummy-i18n";
import { Download } from "@phosphor-icons/react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@stackmorph/ui";

export const BillingHistory = () => {
  // Mock data - in production would come from purchases API
  const purchases: any[] = [];

  return (
    <div className="space-y-4">
      <div>
        <h2 className="text-2xl font-semibold">{t`Billing History`}</h2>
        <p className="text-sm opacity-75">{t`View and download your invoices`}</p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>{t`Past Invoices`}</CardTitle>
          <CardDescription>{t`Download receipts for your records`}</CardDescription>
        </CardHeader>
        <CardContent>
          {purchases.length === 0 ? (
            <div className="py-8 text-center text-sm opacity-75">
              {t`No purchases yet. Upgrade to Premium to see your billing history here.`}
            </div>
          ) : (
            <div className="space-y-4">
              {purchases.map((purchase: any) => (
                <div
                  key={purchase.id}
                  className="flex items-center justify-between rounded-lg border p-4"
                >
                  <div>
                    <div className="font-medium">{purchase.itemId}</div>
                    <div className="text-sm opacity-75">
                      {new Date(purchase.createdAt).toLocaleDateString()}
                    </div>
                  </div>
                  <div className="flex items-center gap-4">
                    <div className="text-lg font-bold">
                      {purchase.currency} {purchase.amount}
                    </div>
                    <button className="rounded p-2 hover:bg-secondary">
                      <Download size={18} />
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};
